module.exports = __webpack_public_path__ + "img/carousel-vet-2.cb5223c0.jpg";